import Dexie, { Table } from 'dexie';
import { IFirefighter } from '../models/ifirefighter.interface';
import { IGroup } from '../models/igroup.interface';
import { KindAlarm } from '../models/kindalarm.model';


export class AppDB extends Dexie {
  firefighters!: Table<IFirefighter, number>;
  groups!: Table<IGroup, number>;
  kinds!: Table<KindAlarm, number>;

  constructor() {
    super('BravoDB');
    this.version(2).stores({
      firefighters: '&id',
      groups: '&id',
      kinds: '&id'
    });
    //this.on('populate', () => this.populate());
  }

  async addFirefighters(firefighters: IFirefighter[]) {
    await db.firefighters.bulkPut(
      firefighters
    );
  }

  async addGroups(groups: IGroup[]) {
    await db.groups.bulkPut(groups);
  }

  async addKindsAlarm(kinds: KindAlarm[]) {
    await db.kinds.bulkPut(kinds);
  }

  async getFirefighters() {
    return await db.firefighters.toArray()
  }

  async getGroups() {
    return await db.groups.toArray();
  }

  async getKindsAlarm() {
    return await db.kinds.toArray();
  }

  async cleanDatabase() {
    await db.firefighters.clear();
    await db.groups.clear();
    await db.kinds.clear();
  }
}

export const db = new AppDB();